<template>
    <div class="" style="">
        <div class="topImgContent">
            <div class="topImgTitleContent">
            <div class="topImgTitle">活动报名记录</div>
            <div class="topImgsubTitle">FUTURE SCIENCE CITY NEWS</div>
            <div class="e-flex menuContent">
                <img class="ic_home" src="@/assets/images/ic_home.png">
                <div class="pointer" @click="goMainPage()">首页</div>
                <div>/</div>
                <div class="pointer" @click="$router.push({ path: (from && from == 1) ? '/index/index' : '/activityRegistration/index', query: {}})">活动报名记录</div>
                <div>/</div>
                <div>正文</div>
                </div>
            </div>
        </div>
        <div class="ard_infoFlex e-flex">
            <div class="ard_infoContent e-flex">
                <img class="ard_img" :src="info.thumbUrl">
                <div class="ard_infoRight">
                    <div class="ard_infoTitle e-line-2">{{ info.activityName}}</div>
                    <div class="ard_baseInfoContent">
                        <div class=" e-flex">
                            <div>时间：</div>
                            <div>{{ info.startTime.slice(0,16) }} 至 {{ info.endTime.slice(0,16) }}</div>
                        </div>
                        <div class=" e-flex">
                            <div>地点：</div>
                            <div>{{ info.endTime }}</div>
                        </div>
                        <div class=" e-flex">
                            <div>人数：</div>
                            <div>{{ info.people < 1 ? '不限' : info.people }}</div>
                        </div>
                    </div>
                </div>
                <div :class="'ard_activityStatus ' + ('ard_activityStatus' + info.process)">{{ info.process == 0 ? '未开始': (info.process == 1 ? '已开始' : '已结束') }}</div>
            </div>
        </div>
        <div class="ard_detailFlex e-flex">
            <div class="ard_detailContent">
                <div class="ard_detailTitle">报名详情</div>
                <div class="ard_detailListContent">
                    <div class="ard_detailList" v-for="(item, index) in info.applyList">
                        <div class="ard_detailListBlock e-flex">
                            <div class="ard_detailListLabel">企业名称</div>
                            <div class="ard_detailListValue">{{ item.company }}</div>
                        </div>
                        <div class="ard_detailListBlock e-flex">
                            <div class="ard_detailListLabel">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名</div>
                            <div class="ard_detailListValueOption">{{ item.name }}</div>
                            <div class="ard_detailListLabel">联系方式</div>
                            <div class="ard_detailListValueOption">{{ item.phone }}</div>
                            <div class="ard_detailListLabel">职&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;务</div>
                            <div class="ard_detailListValueOption">{{ item.duty }}</div>
                        </div>
                        <div class="ard_detailListBlock e-flex ard_borderNone">
                            <div class="ard_detailListLabel">备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注</div>
                            <div class="ard_detailListValue">{{ item.comment }}</div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
        <div class="ard_bottom"></div>
      
    </div>
  </template>
  
  <script>
    import '../../styles/activityRegistration.css'
    export default {
      name: 'activityRegistrationDetail',
      data () {
        return {
          from: '',
          activityId: '',
          info: {},
          user: JSON.parse(localStorage.getItem('user'))
        }
      },
      created() {
        this.from = this.$route.query.from
        this.activityId = this.$route.query.activityId
        this.getDetail()
      },
      methods: {
        goMainPage() {
          this.$emit('goNavPage', {
            key:'1',
            path: ['1'],
            pathId: '1'
          })
        },
        getDetail() {
            this.request({
              url: 'activity/applyDetail',
              method: 'post',
              data: {
                activityId: this.activityId,
                userId: this.user.id ? this.user.id : this.user.data.id
              }
          }).then(res => {
              // let dateStramp = new Date().getTime()
              // let startStamp = new Date(res.data.startTime.slice(0,19)).getTime()
              // let endStamp = new Date(res.data.endTime.slice(0,19)).getTime()
              // if (dateStramp < startStamp) { // 未开始
              //   res.data.activityStatus = 0
              // } else if (dateStramp > startStamp && dateStramp < endStamp) { // 已开始
              //   res.data.activityStatus = 1
              // } else if (dateStramp > endStamp) { // 已结束
              //   res.data.activityStatus = 2
              // }
              this.info = res.data
          })
        }
      }
    }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  
  </style>
  


// WEBPACK FOOTER //
// src/view/activityRegistration/activityRegistrationDetail.vue